import { Component } from "@angular/core";
import { NavController, ViewController } from "ionic-angular";
import { TournamentService } from "../apps/gamer/services/tournament.service";

@Component({
    selector: 'team-settings-modal',
    templateUrl: 'team-settings-modal.html'
})

export class TeamSettingsModal{
    requestedCounters:any;
    counters = [
        {
            name: "POINTS_FOR_THE_WIN",
            value: 0

        },
        {
            name: "POINTS_FOR_A_DRAW",
            value: 0
        },
        {
            name: "POINTS_FOR_THE_LOSS",
            value:  0
        }
    ];
    constructor(
        private gs: TournamentService,
        private viewCtrl: ViewController
    ){ 
        this.gs.requestProfileConfigs().then((res)=>{
            console.log('requestProfileConfigs()', res)
            this.requestedCounters = res;
            this.counters.forEach((counter, index)=>{
                if (index === 0) {
                    counter.value = this.requestedCounters.winScore;
                } else if (index === 1) {
                    counter.value = this.requestedCounters.tieScore;
                } else if (index === 2) {
                    counter.value = this.requestedCounters.lossScore;
                }
                
            })
        })
    }

    update(){
        this.gs.counters.winScore = this.counters[0].value;
        this.gs.counters.tieScore = this.counters[1].value;
        this.gs.counters.lossScore = this.counters[2].value;
        this.gs.saveProfileConfigs();
    }
    dismiss(option) {
        this.viewCtrl.dismiss(option);
    }
}


// WEBPACK FOOTER //
// /src/pages/team-settings-modal/team-settings-modal.ts